var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rsvp-form",attrs:{"no-inner-pad":"","bg":_vm.colors.tan}},[_c('button-block',{attrs:{"label":'RSVP For Pittsburgh',"fg":_vm.colors.paleYellow,"bg":_vm.colors.coral},on:{"click":_vm.goToRSVPForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }